import React, {useEffect, useCallback} from 'react';
import { getMeetups } from '../../services/api';
import { AnimationDelay } from '../Animation';
import Meetup from './Meetup';

import { Container } from './styles';

const Meetups: React.FC = () => {
  const [meetups, setMeetups] = React.useState<IRepoGithub[]>([]);


  const fetchMeetups = useCallback(async () => {
    const fetchedMeetups = await getMeetups()
    console.log(fetchedMeetups);
    
    setMeetups(fetchedMeetups)
  }, []);

  useEffect(() => {
    fetchMeetups()

  }, []);

  return <Container>
    {meetups.map((meetup, index) => (
      <AnimationDelay
        key={meetup.id}
        delay={(index + 1) * 300}
      >
        <Meetup meetup={meetup} />
      </AnimationDelay>
    ))}
  </Container>
}

export default Meetups;
